import React from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { post } from '../../services/api';

let orderId = null;

function Paypal({ isFormValid, placeOrder, callback, disabled }) {
  const validateForm = async (data, actions) => {
    const formValid = await isFormValid();
    if (!formValid) {
      return actions.reject();
    }

    return actions.resolve();
  };

  const initiatePayment = async () => {
    const { response, error } = await placeOrder();

    if (error) {
      return null;
    }

    orderId = response.orderId;
    return response.id;
  };

  const capturePayment = async (data) => {
    const { response, error } = await post(`orders/${orderId}/paypal/capture`, { paymentId: data.paymentID });

    if (error) {
      callback({ paymentResponse: { error } });
    } else {
      callback({ status: response.paymentStatus, paymentResponse: response });
    }
  };

  const onError = () => {
    // console.error('onError', error);
  };

  return (
    <PayPalButtons
      onClick={validateForm}
      createOrder={initiatePayment}
      onApprove={capturePayment}
      onError={onError}
      disabled={disabled}
    />
  );
}

export default Paypal;
